export default "__VITE_ASSET__BrOeqU06__"